export class UserRoleType{
    UserTypeRoleId? : number;
    UserTypeId: number;
    RoleId: string;
}
